import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
export function withFocus(Component) {
    var WithFocus = /** @class */ (function (_super) {
        __extends(WithFocus, _super);
        function WithFocus() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = _this.props.forwardedRef || React.createRef();
            _this.previousFocus = null;
            _this.getPreviousFocus = function () {
                var returnFocusTo = _this.props.returnFocusTo;
                if (returnFocusTo)
                    return returnFocusTo.current;
                if (typeof window !== 'undefined')
                    return document.activeElement;
                return null;
            };
            return _this;
        }
        WithFocus.prototype.componentDidMount = function () {
            var focusOn = this.props.focusOn;
            this.previousFocus = this.getPreviousFocus();
            if (focusOn && focusOn.current)
                return focusOn.current.focus();
            if (this.ref && this.ref.current)
                return this.ref.current.focus();
            return null;
        };
        WithFocus.prototype.componentWillUnmount = function () {
            if (this.previousFocus) {
                this.previousFocus.focus();
            }
        };
        WithFocus.prototype.render = function () {
            var _a = this.props, focusOn = _a.focusOn, returnFocusTo = _a.returnFocusTo, forwardedRef = _a.forwardedRef, props = __rest(_a, ["focusOn", "returnFocusTo", "forwardedRef"]);
            return React.createElement(Component, __assign({ ref: this.ref }, props));
        };
        WithFocus.propTypes = __assign({ focusOn: PropTypes.shape({
                // eslint-disable-next-line react/forbid-prop-types
                current: PropTypes.any,
            }), returnFocusTo: PropTypes.shape({
                // eslint-disable-next-line react/forbid-prop-types
                current: PropTypes.any,
            }) }, Component.propTypes);
        return WithFocus;
    }(React.Component));
    var withRefForwardingFocus = React.forwardRef(
    // Typing a ref forwarding Component accepting not only Class components is not trivial
    // as the following issue describes. However, in the future a viable solution for us could be found in the issue.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35834#issuecomment-497445051
    // @ts-ignore
    function (props, ref) { return React.createElement(WithFocus, __assign({}, props, { forwardedRef: ref })); });
    // PropTypes don't exist on ForwardRefExoticComponents but we want to keep them here.
    // @ts-ignore
    withRefForwardingFocus.propTypes = WithFocus.propTypes;
    return withRefForwardingFocus;
}
//# sourceMappingURL=withFocus.js.map